import Backbone from 'backbone';
import Cache from 'root/cache';
import Constants from 'root/constants';

var User_Invitation = Backbone.Model.extend({
    defaults: {
        account_id         : 0,
        email              : '',
        role               : Constants.ASSIGNEE,
        time               : 0,
        project_ids        : '',
        member_access      : ''
    },

    getRoleName: function() {
        switch (this.get('role')) {
            case Constants.ADMIN:
                return 'Admin';
            case Constants.ASSIGNEE:
                return 'Collaborator';
            case Constants.CLIENT:
                return 'Guest';
            default:
                return '';
        }
    },

    setAccess: function(access_type, access_value, project_id) {
        Cache.app.request({
            action: 'user_invitation/setAccess',
            data: {
                id          : this.id,
                access_type : access_type,
                access_value: access_value,
                project_id  : project_id
            },
            success: (response) => {
                this.set(response);
            }
        });
    },

    hasAccess: function(access_type, project_id) {
        // 1: check access override
        if (this.get('member_access')) {
            var member_access = JSON.parse(this.get('member_access'));
            var access = member_access[project_id] ? member_access[project_id][access_type] : undefined;

            if (access !== undefined) {
                return access;
            }
        }

        // 2: fallback to role access
        return Cache.app.checkRoleAccess(access_type, this.get('role'));
    },
});

export default User_Invitation;